<template>
  <sensor-autocomplete
    id="sensores"
    v-model="sensorId"
    name="sensores"
    :local-id="localId"
    :required="true"
  />
</template>

<script>
import SensorAutocomplete from '../../autocomplete/SensorAutocomplete.vue'

export default {
  name: 'TermoSensor',
  components: { SensorAutocomplete },
  props: {
    localId: {
      type: String,
      required: true,
    },
    initialSensorId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    sensorId: null,
  }),
  watch: {
    sensorId() {
      this.change()
    },
  },
  beforeMount() {
    if (!this.initialSensorId) return
    this.sensorId = this.initialSensorId
  },
  methods: {
    change() {
      this.$emit('change', {
        sensorId: this.sensorId,
      })
    },
  },
}
</script>

<style scoped></style>
